export default {
    BACKEND_API_URL: window.BACKEND_API_URL
        ? window.BACKEND_API_URL
        : 'http://localhost:8000'
};

export const keycloakOptions = {
    realm: window.REACT_APP_REALM ? window.REACT_APP_REALM : 'amb-test',
    url: window.REACT_APP_URL
        ? window.REACT_APP_URL
        : 'https://keycloak.ambsoft.pl',
    'ssl-required': window.REACT_APP_SSL_REQUIRED
        ? window.REACT_APP_SSL_REQUIRED
        : 'external',
    resource: window.REACT_APP_PUBLIC_CLIENT
        ? window.REACT_APP_PUBLIC_CLIENT
        : true,
    'public-client': window.REACT_APP_VERIFY_TOKEN_AUDIENCE
        ? window.REACT_APP_VERIFY_TOKEN_AUDIENCE
        : true,
    'verify-token-audience': window.REACT_APP_USE_RESOURCE_ROLE_MAPPINGS
        ? window.REACT_APP_USE_RESOURCE_ROLE_MAPPINGS
        : true,
    'use-resource-role-mappings': window.REACT_APP_CONFIDENTIAL_PORT
        ? window.REACT_APP_CONFIDENTIAL_PORT
        : 0,
    'confidential-port': window.REACT_APP_CONFIDENTIAL_PORT
        ? window.REACT_APP_CONFIDENTIAL_PORT
        : 0,
    clientId: window.REACT_APP_CLIENTID
        ? window.REACT_APP_CLIENTID
        : 'vms-urlopy-prod'
};

export const disabledDays = [
    '01-01-2019', '6-01-2019', '21-04-2019', '22-04-2019', '01-05-2019', '03-05-2019', '09-06-2019',
    '20-06-2019', '15-08-2019', '01-11-2019', '11-11-2019', '25-12-2019', '26-12-2019',
    '01-01-2020', '6-01-2020', '12-04-2020', '13-04-2020', '01-05-2020', '03-05-2020', '31-05-2020',
    '11-06-2020', '15-08-2020', '01-11-2020', '11-11-2020', '25-12-2020', '26-12-2020',
];



// WEBPACK FOOTER //
// ./src/config.js